import { usePatientProfile } from 'apps/wrapper/src/hooks/use-patient-profile';
import { FC, useMemo } from 'react';
import { AllCommunicationSection, CommunicationSubSection, Section, SelectAllSection, Separator } from './comm-preferences.styles';


type CommPreferencesTextViewProps = {
  setChange: (key: string, value: any) => void;
  changes: any;
};

export const CommPreferencesTextView: FC<CommPreferencesTextViewProps> = ({ setChange, changes }) => {
  const { patientPreferences } = usePatientProfile();

  const localPreferences = useMemo(
    () => changes.updateLocalPreferences || patientPreferences,
    [patientPreferences, changes]
  );

  const updateLocalPreferences = (state: Partial<typeof patientPreferences>) => {
    const newState = { ...patientPreferences, ...changes.updateLocalPreferences, ...state };

    setChange('updateLocalPreferences', newState);
  };

  return (
    <div>
      <Section>
        <SelectAllSection>
          <AllCommunicationSection
            text="All Text Messages"
            isChecked={
              localPreferences.textAppointmentReminders &&
              localPreferences.textPatientReactivation &&
              localPreferences.textRecalls &&
              localPreferences.textReviewsAndSurveys &&
              localPreferences.textSpecialsAndNewsletters &&
              localPreferences.textTreatmentPlanFollowUps
            }
            onChange={(value) =>
              updateLocalPreferences({
                textAppointmentReminders: value,
                textPatientReactivation: value,
                textRecalls: value,
                textReviewsAndSurveys: value,
                textSpecialsAndNewsletters: value,
                textTreatmentPlanFollowUps: value
              })
            }
          />
        </SelectAllSection>
        <Separator>Essential Communications</Separator>
        <CommunicationSubSection
          text="Appointment Reminders"
          isChecked={localPreferences.textAppointmentReminders}
          onChange={(value) => updateLocalPreferences({ textAppointmentReminders: value })}
        />
        <CommunicationSubSection
          text="Patient Reactivation"
          isChecked={localPreferences.textPatientReactivation}
          onChange={(value) => updateLocalPreferences({ textPatientReactivation: value })}
        />
        <CommunicationSubSection
          text="Recalls"
          isChecked={localPreferences.textRecalls}
          onChange={(value) => updateLocalPreferences({ textRecalls: value })}
        />
        <Separator>Marketing & Promotional</Separator>
        <CommunicationSubSection
          text="Treatment Plan Follow-ups"
          isChecked={localPreferences.textTreatmentPlanFollowUps}
          onChange={(value) => updateLocalPreferences({ textTreatmentPlanFollowUps: value })}
        />
        <CommunicationSubSection
          text="Reviews & Surveys"
          isChecked={localPreferences.textReviewsAndSurveys}
          onChange={(value) => updateLocalPreferences({ textReviewsAndSurveys: value })}
        />
        <CommunicationSubSection
          text="Specials & Newsletters"
          isChecked={localPreferences.textSpecialsAndNewsletters}
          onChange={(value) => updateLocalPreferences({ textSpecialsAndNewsletters: value })}
        />
      </Section>
    </div>
  );
};
